import KhilanetPage from './KhilanetPage';
export default KhilanetPage;
